<template>
    <div class="carousel-bullet-nav">
        <ul class="u-reset carousel-bullet-nav--bullets">
            <li class="carousel-bullet-nav--bullet" v-for="(bullet, bulletIdx) in numItems">
                <button class="carousel-bullet-nav--bullet-link"
                        :class="[bemAdd(activeIdx === bulletIdx ? 'is-active' : '', 'bullet-link')]"
                        @click.prevent="changeHandler(bulletIdx)">
                    <span class="carousel-bullet-nav--bullet-icon"></span>
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';


    export default {
        mixins: [
            bemMixin('carousel-bullet-nav'),
        ],
        props: {
            numItems: {
                type: Number,
                required: true,
            },
            activeIdx: {
                type: Number,
                required: true,
            },
            changeHandler: {
                type: Function,
                required: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/ui/carousel/carousel-bullet-nav/index.vue?24647022